import React, { useEffect, useState } from 'react'
import styles from './index.module.scss'

const Countdown = () => {
	const [days, setDays] = useState('00')
	const [hours, setHours] = useState('00')
	const [minutes, setMinutes] = useState('00')
	const [seconds, setSeconds] = useState('00')
	const [timeUp, setTimeUp] = useState(false)

	const day_string = days > 1 ? 'Days' : 'Day'

	useEffect(() => {
		setInterval(() => {
			let eventDate = +new Date("04/04/2026");
			let difference = eventDate - +new Date();
			if (difference < 1) {
				setTimeUp(true)
			} else {
				let days = Math.floor(difference / (1000 * 60 * 60 * 24));
				let hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
				let minutes = Math.floor((difference / (1000 * 60)) % 60);
				let seconds = Math.floor((difference / (1000)) % 60);
				setHours(hours > 9 ? hours : `0${hours}`)
				setMinutes(minutes > 9 ? minutes : `0${minutes}`)
				setSeconds(seconds > 9 ? seconds : `0${seconds}`)
				setDays(days)
			}
		}, 1000)
	})
	
	return (
		<section className={styles.countdown_section}>
			<div className={styles.container}>
				{/* <h2 className={styles.heading}>Conference Countdown</h2> */}
				<div className={styles.countdown}>
					<div className={styles.countdown_item}>
						<h2 className={styles.countdown_number}>{days}</h2>
						<p className={styles.countdown_text}>{day_string}</p>
					</div>
					<div className={styles.countdown_colon}>:</div>
					<div className={styles.countdown_item}>
						<h2 className={styles.countdown_number}>{hours}</h2>
						<p className={styles.countdown_text}>Hours</p>
					</div>
					<div className={styles.countdown_colon}>:</div>
					<div className={styles.countdown_item}>
						<h2 className={styles.countdown_number}>{minutes}</h2>
						<p className={styles.countdown_text}>Minutes</p>
					</div>
					<div className={styles.countdown_colon}>:</div>
					<div className={styles.countdown_item}>
						<h2 className={styles.countdown_number}>{seconds}</h2>
						<p className={styles.countdown_text}>Seconds</p>
					</div>
				</div>
			</div>
		</section>
	)
}

export default Countdown